import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, message, Popconfirm, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ContentWithErrorHandler from "../../app/ContentWithErrorHandler";
import { basicSortDateString, TableColumnTextFilterConfig } from "../../common/TableHelper";
import { useDeleteDocumentMutation, useGetAllDocumentQuery } from "./documentAPI";
import { Document } from "./types";

interface TagItem {
  text: string;
  value: string;
}

function DocumentList() {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetAllDocumentQuery();
  const [deleteDocument] = useDeleteDocumentMutation();

  const [tags, setTags] = useState<TagItem[]>([]);

  useEffect(() => {
    if (data) {
      let tagList = data.flatMap((element) => element.tags);
      let tagListName = tagList.map((element) => element.name);
      tagListName = [...new Set(tagListName)];
      setTags(
        tagListName.map(
          (e: any): TagItem => {
            return { text: e, value: e };
          }
        )
      );
    }
  }, [data]);

  const getDate = (stringDate) => {
    return new Date(stringDate).toLocaleDateString("id-ID");
  };

  return (
    <ContentWithErrorHandler isError={error} isLoading={false}>
      <Card
        title="Data Dokumen"
        size="small"
        extra={
          <div>
            <Button style={{ borderRadius: 5 }}>
              <Link to="create">+ Tambah Baris</Link>
            </Button>
          </div>
        }
      >
        <Table
          loading={isLoading}
          dataSource={data}
          bordered
          size="small"
          pagination={{ pageSize: 10 }}
          columns={[
            {
              title: "Status",
              dataIndex: "isPublished",
              key: "isPublished",
              render: (text, record) => {
                if (!record.isPublished) {
                  return <Tag color="red">DRAF</Tag>;
                } else {
                  return <Tag color="geekblue">TERBIT</Tag>;
                }
              },
              width: "5%",
            },
            {
              title: "Akses",
              dataIndex: "isPublic",
              key: "isPublic",
              render: (text, record) => {
                if (!record.isPublic) {
                  return <Tag color="orange">Khusus Anggota</Tag>;
                } else {
                  return <Tag color="green">Semua Orang</Tag>;
                }
              },
              width: "5%",
            },
            {
              title: "Tanggal Publikasi",
              dataIndex: "createdAt",
              key: "createdAt",
              width: "10%",
              sorter: (a, b) => basicSortDateString(a.createdAt, b.createdAt),
              render: (createdAt) => {
                return <> {getDate(createdAt)} </>;
              },
            },
            {
              title: "Kategori",
              dataIndex: "tags",
              key: "tags",
              width: "25%",
              filters: tags,
              onFilter: (value: any, record) => record.tags.map((e) => e.name).includes(value),
              render: (tag) => (
                <>
                  {tag.map((element) => {
                    return (
                      <Tag color="blue" key={element}>
                        {element.name}
                      </Tag>
                    );
                  })}
                </>
              ),
            },
            {
              title: "Nama Dokumen",
              dataIndex: "name",
              key: "name",
              width: "40%",
              ...TableColumnTextFilterConfig<Document>("name"),
            },
            {
              title: "Aksi",
              key: "x",
              width: "10%",
              render: (text, record) => (
                <div>
                  <Button type="link" icon={<EditOutlined />} style={{ borderRadius: 5 }} onClick={() => navigate(`detail/${record.id}`)} />
                  <Popconfirm
                    title="Apakah anda yakin?"
                    onConfirm={() => {
                      const hideLoading = message.loading("Loading", 0);
                      deleteDocument(record.id)
                        .unwrap()
                        .then(() => {
                          hideLoading();
                          message.success("Berhasil!");
                        })
                        .catch(() => {
                          hideLoading();
                          message.error("Gagal!");
                        });
                    }}
                    okText="Hapus"
                    cancelText="Batal"
                  >
                    <Button type="link" danger icon={<DeleteOutlined />} style={{ borderRadius: 5 }} />
                  </Popconfirm>
                </div>
              ),
            },
          ]}
        />
      </Card>
    </ContentWithErrorHandler>
  );
}

export default DocumentList;
